import Entity from '../entity'

export default class Figure extends Entity<number>{
    dealer_id: number;
    vehicle_type_id: number;
    state_id: number;
    year: number;
    month: number;
    published: boolean;
}


